import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';
export const routes = [
    {
        component: lazy(() => import('module/site/SiteListPage')),
        permissions: ['Site_Read', 'Site_Create', 'Site_Edit', 'Site_Delete'],
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.SystemAdministrator,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: '/',
    },
];
